// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__cdc23f0ca1ab4a23e688","cls2":"CreateSocialItemModal-cls2___dadc5b95a12626c0a52 CreateSocialItemModal-cls1__cdc23f0ca1ab4a23e688"};